module.exports = {
  default: {
    MEDIA_ROOT: 'https://d178fu9mi2dmkb.cloudfront.net/webapp-media',
    NODE_ENV: 'production',
    SERVER_PORT: 3000,
  },
  // These are environment variables required at runtime, by either or both the Node and React apps
  // All variables are taken from the environment and configured into a single object exported below
  // Public variables are instantiated into global scope by config/globals.js, and rendered in HTML
  // Private variables (secrets) are accessible from
  // e.g. config.SECRET and are not send over the wire
  public: [
    'API_ROOT',
    'API_ROOT_EXTERNAL',
    'API_SEARCH',
    'AUTH0_CLIENT_DOMAIN',
    'AUTH0_CLIENT_ID',
    'ASSETS_ROOT',
    'FACEBOOK_APP_ID',
    'GA_TRACKING_ID',
    'GMAPS_API_KEY',
    'GQL_ROOT',
    'GQL_ROOT_EXTERNAL',
    'IPSTACK_API_KEY',
    'LM2018_COMPETITION_END',
    'LM2018_COMPETITION_START',
    'MEDIA_ROOT',
    'OPTIMIZELY_PROJECT_ID',
    'POSTCODER_API_KEY',
    'SEGMENT_ID',
    'SENTRY_PUBLIC_KEY',
    'SENTRY_PROJECT_ID',
    'STRIPE_CLIENT_ID',
    'STRIPE_PUBLIC_KEY',
    'WEB_ROOT',
  ],
  private: [
    'AUTH0_CLIENT_SECRET',
    'STRIPE_CLIENT_SECRET',
  ],
};



//////////////////
// WEBPACK FOOTER
// ./app/config/variables.js
// module id = 1113
// module chunks = 27